function o(e) {
  var r;
  return ((r = e.match(/[a-z]+/gi)) == null ? void 0 : r.map((t) => t.charAt(0).toUpperCase() + t.substring(1).toLowerCase()).join("")) ?? "";
}
function c(e, r = !1) {
  e = e.toLowerCase();
  let t = e.replace(
    /\w\S*/g,
    (n) => n.charAt(0).toUpperCase() + n.substring(1).toLowerCase()
  );
  return r && (t = t.replace(/\s/g, "")), t;
}
function u(e, r) {
  return e.toLowerCase().includes(r.toLowerCase());
}
function i(e, r) {
  return e.toLowerCase().indexOf(r.toLowerCase()) === 0;
}
function s(e, r) {
  return e === r ? !0 : !e || !r ? !1 : e.toLowerCase() === r.toLowerCase();
}
function a(e) {
  return e.trim().replace(/\s+/gm, " ").toLowerCase();
}
function l(e, r) {
  switch (a(e)) {
    default:
      return `${e}${r === 1 ? "" : "s"}`;
  }
}
function C(e, r, t = !1) {
  return e.replace(new RegExp(`(${r})`, t ? "gi" : "i"), "<b>$1</b>");
}
function f(e, r = "-") {
  return e.toLowerCase().trim().replace(/_/g, r).replace(/[^A-z]+/g, r).replace(new RegExp(`${r}+`, "g"), r).replace(/-$|^-/g, "");
}
export {
  c as capitalize,
  s as equalInLC,
  f as getClassName,
  l as getEnding,
  u as includesInLC,
  C as markMatch,
  a as prepareForMatching,
  i as startsFromInLC,
  o as toPascalCase
};
